module.exports = __webpack_public_path__ + "img/sales-manager.94820d40.png";